import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { DataService } from "../dataService/data.service";
// import { CustomDateFormatter } from './custom-date-formatter.provider';
import { GlobalVariable } from "../app.component";
import { Subject } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
  CalendarMonthViewBeforeRenderEvent,
  CalendarDateFormatter,
} from "angular-calendar";
import { CustomDateFormatter } from "../customer-appointment-booking/custom-date-formatter.provider";

import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";

@Component({
  selector: "app-delete-appoinement",
  templateUrl: "./delete-appoinement.component.html",
  styleUrls: ["./delete-appoinement.component.scss"],
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter,
    },
  ],
})
export class DeleteAppoinementComponent implements OnInit {
  // @ViewChild('conformationModel', { read: ElementRef }) conformationModel: ElementRef;
  @ViewChild("conformationModel", { static: true })
  conformationModel: ElementRef;
  BASE_URL = GlobalVariable;
  slug: string;
  refresh: Subject<any> = new Subject();
  loading: boolean = false;
  slug_value: string;
  appointment_data: any;
  name: any;
  category_name: any;
  slot_time: any;
  notes: any;
  phone_number: any;
  id: any;
  deleteButtonVisible = true;
  date: any;
  businessName: any;
  businessLogo: any;
  // is_link_expired : boolean;
  is_link_expired: boolean = false;
  hideDeleteBtn: boolean;
  ownerNumber: string;
  appointmentFlexFields: any = [];

  constructor(
    private httpService: DataService,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.route.params.forEach((val) => {
      this.slug_value = val["id"];
    });
    console.log(this.slug_value);
    this.getInitialData();
  }
  confimDelete() {
    this.modalService.open(this.conformationModel, { size: "lg" });
  }
  confimDeleteClose() {
    this.modalService.dismissAll(this.conformationModel);
  }
  getInitialData() {
    this.loading = true;
    this.httpService
      .getRequest({
        customApiUrl:
          this.BASE_URL.GET_DELETE_APPOINTMENT_SLUG + "/" + this.slug_value,
      })
      .subscribe(
        (data: any) => {
          this.loading = false;
          if (data.code === 200) {
            this.ownerNumber = data.data.owner_number;
            this.phone_number = data.data.appointments[0].phone_number;
            this.notes = data.data.appointments[0].notes;
            this.slot_time = moment(data.data.appointments[0].slot_time, [
              "HH:mm",
            ]).format("hh:mm A");
            this.category_name = data.data.appointments[0].category_name;
            this.name = data.data.appointments[0].name;
            this.id = data.data.appointments[0].id;
            this.appointment_data = data.data.appointments[0].appointment_id;
            this.businessLogo = data.data.business_logo;
            this.businessName = data.data.business_name;
            this.date = moment(
              data.data.appointments[0].date,
              "YYYY-MM-DD"
            ).format("DD-MM-YYYY");
            // this.date = moment("2020-6-21", 'YYYY-MM-DD').format('DD-MM-YYYY');

            this.hideDeleteBtn = moment(this.date, "DD-MM-YYYY").isBefore(
              moment(new Date()),
              "date"
            );
            const appointmentFlexFields =
              data.data.appointments[0].appointment_flex_details;

            ((flexFields) => {
              if (flexFields.length !== 0) {
                flexFields.forEach((field) => {
                  this.appointmentFlexFields.push({
                    name: field.name == null ? "" : field.name,
                    content: field.content == null ? "" : field.content,
                    input_type:
                      field.input_type == null ? "" : field.input_type,
                  });
                });
              } else {
                this.appointmentFlexFields = [];
              }
            })(appointmentFlexFields);
            console.log("hideDeleteBtn", this.hideDeleteBtn);
          }
          console.log("date", this.date);
          console.log(moment(new Date()));
        },
        (error) => {
          this.loading = false;
          this.is_link_expired = true;
          console.log("link expired", this.is_link_expired);
        }
      );
  }
  deleteAppointment(appointment_data) {
    var res: Response;
    const deleteAppointment = this.httpService.delete(
      this.BASE_URL.DELETE_APPOINTMENT + "/" + this.id
    );
    // const deleteAppointment = this.httpService.delete(
    //   this.BASE_URL.DELETE_APPOINTMENT(this.slug_value, this.id)
    // );
    deleteAppointment.subscribe(
      (data: any) => {
        this.hideDeleteBtn = true;
        // res = data;
        console.log(data);
        this.toastrService.success("Deleted Appointment");
        // this.deleteButtonVisible = false;
        // this.phone_number = ''
        // this.notes = ''
        // this.slot_time = ''
        // this.category_name = ''
        // this.name = ''
        // this.id = ''
        // this.date= ''
        this.confimDeleteClose();
        this.modalService.dismissAll();
      },
      (error) => {
        this.toastrService.error(error.error.message);
        this.confimDeleteClose();
      },
      () => {}
    );
  }
}
